import axios from "axios";
import config from "../../settings/config";
import { handleError } from "../../network/servicErrorHandling";

async function usersCurrentOrders() {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/users/current/orders`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}
async function orderDetail(order_uid) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/orders/${order_uid}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

export { usersCurrentOrders, orderDetail };
